var i18n = {
  'en-US': {
    drawerTitle: 'Version record',
    popconfirmTitle: 'Are you sure to reset the theme to the default Arco style? After reset, it needs to be republished to take effect in the npm package~',
    resetBtn: 'Reset theme configuration to initial state',
    versionBackLabel: 'Select a fallback version',
    versionBackPlaceholder: 'Please select a fallback version',
    rollbackWarningModalTitle: 'Please select a fallback version',
    rollbackWarningModalLabel: 'Fallback version:',
    rollbackWarningModalDesc1: '1. There is a certain risk in version rollback, please back up the theme first.',
    rollbackWarningModalDesc2: '2. Perform version rollback, and the current editing status will be cleared.',
    rollbackWarningModalDesc3: '3. The description related to the custom function color cannot be restored at present.',
    rollbackWarningModalDesc4: '4. If the theme fails to roll back and the theme cannot operate normally, please feedback the problem to the official personnel for processing.',
    rollbackWarningModalCancel: 'Cancel',
    rollbackWarningModalConfirm: 'Confirm',
    rollbackSuccessTip: 'Rollback succeeded, refreshing'
  },
  'zh-CN': {
    drawerTitle: '版本记录',
    popconfirmTitle: '是否确认重置主题为默认的Arco样式？重置后需重新发布才能在 npm 包中生效哦～',
    resetBtn: '重置主题配置为初始状态',
    versionBackLabel: '选择回退版本',
    versionBackPlaceholder: '请选择回退版本',
    rollbackWarningModalTitle: '版本回退说明',
    rollbackWarningModalLabel: '回退版本：',
    rollbackWarningModalDesc1: '1、版本回退存在一定风险，请先行对主题进行备份操作。',
    rollbackWarningModalDesc2: '2、进行版本回退，当前编辑状态将会被清除。',
    rollbackWarningModalDesc3: '3、自定义颜色相关的描述暂时无法恢复。',
    rollbackWarningModalDesc4: '4、如若主题回退失败，导致主题无法进行正常操作，请将问题反馈给官方人员进行处理。',
    rollbackWarningModalCancel: '取消',
    rollbackWarningModalConfirm: '确认',
    rollbackSuccessTip: '回退成功，正在刷新'
  }
};
export default i18n;